<template>
  <div id="app">
    <div class='routerPages'>
      <router-view class="pageRouter"/>
    </div>
  </div>
</template>

<script>
import store from "@/store";

export default {
  name: 'App',
  store: store,
  methods: {
  },
  mounted(){
    let x=window.innerWidth;
    document.documentElement.style.fontSize = x/19.2+"px";
    window.onresize=function(){
      let x=window.innerWidth;
      document.documentElement.style.fontSize = x/19.2+"px";
    }
  }
}
</script>

<style lang='less'>
html,body{
  font-family:"微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  padding:0;
  margin:0;
  border:0;
  overflow: hidden;

  /* background: black; */

  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}
div{
  padding:0;
  margin:0;
  border:0;
}
#app{
  width: 100%;
  height: 100%;
  padding:0;
  margin:0;
  border:0;
}
.routerPages{
  position:absolute;
  /* background: white; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue